module.exports = __webpack_public_path__ + "static/media/blank_slider.f05ccfeb.jpg";